module.exports = "<template><due-display item.bind=\"item\" value.bind=\"value\"></due-display></template>\n";